export default {"src":"/_next/static/media/circleInfoActive_16.13805f3f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};